module.exports = __webpack_public_path__ + "img/slideLeft.5bf296f8.gif";